import firebase from "@/plugins/firebase"
import User from "@/domain/user"

const userRef = firebase.firestore().collection("users")

export default class UserRepository {
  static async findOne(uid) {
    return new Promise(async (resolve, reject) => {
      try { 
        // user get
        let user = await userRef.doc(uid).get()
        if (!user.exists) { reject(new Error(`user: ${uid} は見つかりませんでした。`)) }
        let userData = { id: user.id, data: user.data() }
  
        // user validate
        let userValidateResult = User.validate(userData)
        if(userValidateResult.isInvalid) { reject(userValidateResult.errors) }
  
        console.log("userData: ")
        console.log(userData)
        resolve(userData)
      } catch(error) {
        console.log(error)
        reject(error)
      }
    });  
  }

  static async save(user) {
    return new Promise(async (resolve, reject) => {
      let validateResult = User.validate(user)
      if(validateResult.isInvalid) {
        reject(validateResult.errors)
      }
  
      try {
        await userRef.doc(uid).set(user)
        resolve()
      }catch(error) {
        reject(error)
      }
    });
  }
}
